export function buildImageSource(
    images?: string | Inspire.Image[],
    namespace: string = '',
): string | undefined {
    if (!images || typeof images === 'string') {
        return images;
    }

    const filteredImages = images.filter((image) => image.url.includes(namespace));

    const [largestImage] = (filteredImages.length > 0 ? filteredImages : images).sort(
        (left, right) => right.width - left.width,
    );

    return largestImage?.url;
}

export function buildImageSourceSet(
    images?: string | Inspire.Image[],
    namespace: string = '',
): string | undefined {
    if (!images || typeof images === 'string') {
        return undefined;
    }

    return images
        .filter((image) => image.url.includes(namespace))
        .sort((left, right) => left.width - right.width)
        .map((image) => `${image.url} ${image.width}w`)
        .join(', ');
}

export function getBaseImageUrl(images?: string | Inspire.Image[]): string | undefined {
    if (!images) {
        return undefined;
    }

    if (typeof images === 'string') {
        return images;
    }

    return images[0]?.url;
}
